import React, { useEffect, useState } from "react";
import { Loader } from "@googlemaps/js-api-loader";
import { GOOGLE_MAPS_API_KEY, shouldUseLiveMap } from "../config/rideMap";
import GMap from "./GMap";
import RideMapLegend from "./RideMapLegend";
import StaticRideMap from "./StaticRideMap";

function loadGoogleMapsApi(onReady) {
  let cancelled = false;

  new Loader({
    apiKey: GOOGLE_MAPS_API_KEY,
    version: "weekly",
  })
    .load()
    .then(() => {
      if (!cancelled) {
        onReady();
      }
    })
    .catch((error) => {
      console.error(
        "Sorry, something went wrong: Please try again later. Error:",
        error
      );
    });

  return () => {
    cancelled = true;
  };
}

function RideDetailsMap({ item, type }) {
  const useLive = shouldUseLiveMap(item?.status);
  const [liveApiReady, setLiveApiReady] = useState(false);

  useEffect(() => {
    if (!useLive) {
      setLiveApiReady(false);
      return;
    }

    return loadGoogleMapsApi(() => setLiveApiReady(true));
  }, [useLive]);

  if (!item?.uuid) {
    return <div>Loading...</div>;
  }

  let mapView = <StaticRideMap item={item} />;
  if (useLive) {
    mapView = liveApiReady ? <GMap item={item} type={type} /> : <div>Loading...</div>;
  }

  return (
    <div className="ride-map">
      {mapView}
      <RideMapLegend />
    </div>
  );
}

export default RideDetailsMap;
